//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Layout from '@/components/ResponsiveLayout'
import SwoopForm from '@/components/SwoopForm'
import gql from 'graphql-tag'

export default {
  name: 'UserProfile',

  components: {
    Layout,
    SwoopForm
  },

  data() {
    return {
      form: null,
      fields: [],
      me: {},
      loading: false
    }
  },

  apollo: {
    me: {
      query: gql`
        query Query {
          me {
            id
            first_name
            last_name
            email
            contact_number
            contact {
              id
              parent
              parent_id
              first_name
              last_name
              login_id
              reference_name
              contact_type
              email_address
              direct_number
              mobile_number
              office_number
              fax_number
              unit_number
              number
              street
              city
              state
              post_code
            }
          }
        }
      `
    }
  },

  created() {
    this.getFields()
  },

  computed: {
    title() {
      if (this.me.first_name && this.me.last_name) {
        return `${this.me.first_name} ${this.me.last_name}`
      }
      return this.me.first_name || this.me.last_name || ''
    },
    initials() {
      let initials = ''
      if (this.me.first_name) {
        initials += this.me.first_name.substr(0, 1).toUpperCase()
      }
      if (this.me.last_name) {
        initials += this.me.last_name.substr(0, 1).toUpperCase()
      }
      return initials
    }
  },

  methods: {
    reset() {
      this.form.reset()
      this.getFields()
    },

    async updateUser() {
      if (this.form.focusError()) {
        return
      }

      let updateData = {
        id: this.me.id,
        first_name: this.me.first_name,
        last_name: this.me.last_name,
        email: this.me.email,
        contact_number: this.me.contact_number,
        contact: {
          id: this.me.contact.id,
          parent: this.me.contact.parent,
          parent_id: this.me.contact.parent_id,
          first_name: this.me.contact.first_name,
          last_name: this.me.contact.last_name,
          login_id: this.me.contact.login_id,
          reference_name: this.me.contact.reference_name,
          contact_type: this.me.contact.contact_type,
          email_address: this.me.contact.email_address,
          direct_number: this.me.contact.direct_number,
          mobile_number: this.me.contact.mobile_number,
          office_number: this.me.contact.office_number,
          fax_number: this.me.contact.fax_number,
          unit_number: this.me.contact.unit_number,
          number: this.me.contact.number,
          street: this.me.contact.street,
          city: this.me.contact.city,
          post_code: this.me.contact.post_code,
          state: this.me.contact.state
        }
      }

      this.loading = true

      await this.$apollo
        .mutate({
          mutation: gql`
            mutation($input: UserInput!) {
              updateUser(input: $input) {
                id
                first_name
                last_name
                email
                contact_number
                contact {
                  id
                  parent
                  parent_id
                  first_name
                  last_name
                  login_id
                  reference_name
                  contact_type
                  email_address
                  direct_number
                  mobile_number
                  office_number
                  fax_number
                  unit_number
                  number
                  street
                  city
                  state
                  post_code
                }
              }
            }
          `,
          variables: {
            input: updateData
          }
        })
        .then(data => {
          this.$set(this, 'me', data.data.updateUser)
          this.loading = false
        })
        .catch(() => {})
    },

    getFields() {
      let fields = [
        { heading: 'Details', size: 'small' },
        {
          id: 'first_name',
          type: 'name',
          label: 'First name',
          required: true
        },
        {
          id: 'last_name',
          label: 'Last name',
          type: 'name',
          required: true
        },
        {
          id: 'contact.reference_name',
          label: 'Reference name',
          type: 'name'
        },
        {
          id: 'email',
          label: 'Email',
          type: 'email',
          required: true
        },
        {
          id: 'contact.contact_type',
          label: 'Contact type',
          type: 'list',
          options: [
            'Technical contact',
            'Account contact',
            'Site contact',
            'Provisioning contact'
          ],
          required: true
        },
        { heading: 'Phone', size: 'small' },
        {
          id: 'contact_number',
          type: 'phone',
          label: 'Direct phone number'
        },
        {
          id: 'contact.mobile_number',
          type: 'phone',
          label: 'Mobile'
        },
        {
          id: 'contact.office_number',
          type: 'phone',
          label: 'Office number'
        },
        {
          id: 'contact.fax_number',
          type: 'phone',
          label: 'Fax number'
        },

        { heading: 'Address', size: 'small' },
        {
          id: 'contact.unit_number',
          label: 'Unit number'
        },
        {
          id: 'contact.number',
          label: 'Street number'
        },
        {
          id: 'contact.street',
          label: 'Street name',
          case: 'title'
        },
        {
          id: 'contact.city',
          label: 'City',
          case: 'title'
        },
        {
          id: 'contact.post_code',
          label: 'Postcode'
        },
        {
          id: 'contact.state',
          label: 'State',
          type: 'list',
          options: [
            { label: 'New South Wales', value: 'NSW' },
            { label: 'Queensland', value: 'QLD' },
            { label: 'Victoria', value: 'VIC' },
            { label: 'South Australia', value: 'SA' },
            { label: 'Western Australia', value: 'WA' },
            { label: 'Australian Capital Territory', value: 'ACT' },
            { label: 'Northern Territory', value: 'NT' },
            { label: 'Tasmania', value: 'TAS' }
          ]
        }
      ]
      this.fields = fields
    }
  }
}
